import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import paperPlaneTopIcon from '@/core/svg/fa/paper-plane-top.svg';
import { forwardRef } from 'react';
import { ActionIconTemplate } from './ActionIconTemplate';
export const SendActionIcon = forwardRef((props, ref) => (_jsx(ActionIconTemplate, { ref: ref, ...props, icon: paperPlaneTopIcon, defaultTitle: t('send.label') })));
